import { Icon } from "./Icon.tsx";

/** "Simulation options" icon — a slider/settings glyph, distinct from SettingsMenu.tsx's own gear (that one is theme/language/build info, this one is project simulation settings). */
export function OptionsIcon() {
  return (
    <Icon>
      <path d="M4 6h10M17 6h3M4 12h4M11 12h9M4 18h13M20 18h0" />
      <circle cx="14" cy="6" r="2" />
      <circle cx="7" cy="12" r="2" />
      <circle cx="17" cy="18" r="2" />
    </Icon>
  );
}
